import { ProjectsReducerCreator } from '../types';

const clearProjectsReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state) => {
    state.projects = [];
    state.projectsTotals = null;
  });
};

export default clearProjectsReducer;
